import { Fragment, useState } from 'react';
import axios from "axios";
import API_ROUTES from "../../../config/api";
import { Formik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";

const BankWelcome = ({ state, updateState, nextStep, addToStore }) => {
  const navigate = useNavigate();

  const [currentKey, setCurrentKey] = useState(0);

  return (
    <Formik
      initialValues={{
        primary_email: state?.data?.company_details?.organisation_name || '',
        contact_number: state?.data?.contact_information?.contact_number || '',
      }}
      validationSchema={Yup.object().shape({
        primary_email: Yup.string()
          .email('Invalid email address')
          .required('Email address is required'),
        contact_number: Yup
          .string('Must be a valid phone number')
          .required('Contact number is required'),
      })}
      onSubmit={async (values, {
        setSubmitting,
        setFieldValue,
      }) => {
        setSubmitting(true);

        await axios.post(API_ROUTES.onboarding['application:director:create'](state.store.company_id), {
          firstname: state.store.posc[currentKey].firstname,
          middle_names: state.store.posc[currentKey].middle_names,
          lastname: state.store.posc[currentKey].lastname,
          address: state.store.posc[currentKey].address,
          city: state.store.posc[currentKey].city,
          zip: state.store.posc[currentKey].zip,
          country: state.store.posc[currentKey].country,
          posc_email: values.primary_email,
          phone: values.contact_number,
        });

        if (state.store.posc.length === currentKey + 1) {
          await axios.post(API_ROUTES.onboarding['application:update'](state.store.company_id), {
            dealstage: '147397080',
          });

          navigate(`/${state.store.company_id}/status`)
        }

        await setFieldValue('primary_email', '');
        await setFieldValue('contact_number', '');
        setCurrentKey(currentKey + 1);
        setSubmitting(false);
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
        setFieldValue,
      }) => (
        <Fragment>
          <form action="#" method="POST" onSubmit={handleSubmit}>

            <h1 className="text-2xl font-semibold mb-6">Person with Significant Control <small>({currentKey + 1} of {state.store.posc.length})</small></h1>

            <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">

              <div className="sm:col-span-2 mb-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  Name
                </label>
                <p>{state.store.posc[currentKey].firstname}{state.store.posc[currentKey].middle_names ? ` ${state.store.posc[currentKey].middle_names} ` : ''} {state.store.posc[currentKey].lastname}</p>
              </div>

              <div className="sm:col-span-2 mb-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  Address
                </label>
                <p>{state.store.posc[currentKey].address}, {state.store.posc[currentKey].city}, {state.store.posc[currentKey].zip}</p>
              </div>

              <div className="sm:col-span-2 mb-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  Contact email address *
                </label>
                <div className="mt-2.5">
                  <input type="text"
                    name="primary_email"
                    id="primary_email"
                    value={values.primary_email}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    autoComplete="organization"
                    placeholder={'e.g. help@your-agency.com'}
                    className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.primary_email && errors.primary_email ? ' border-red-500' : ''}`}
                  />
                  {touched.primary_email && errors.primary_email && <div className="field-error">{errors.primary_email}</div>}
                </div>
              </div>

              <div className="sm:col-span-2 mb-2">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
                  Contact phone number *
                </label>
                <div className="mt-2.5">
                  <input type="text"
                    name="contact_number"
                    id="contact_number"
                    value={values.contact_number}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    autoComplete="organization"
                    placeholder={'e.g. 020 8254 3062'}
                    className={`block appearance-none w-full rounded-md border border-gray-200 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500${touched.contact_number && errors.contact_number ? ' border-red-500' : ''}`}
                  />
                  {touched.contact_number && errors.contact_number && <div className="field-error">{errors.contact_number}</div>}
                </div>
              </div>

            </div>

            <div className="mt-12">
              <button type="submit"
                disabled={isSubmitting}
                className="bg-purple-800 disabled:bg-purple-200 hover:bg-purple-900 text-white font-semibold rounded-md py-2 px-4 w-full">
                {isSubmitting && (
                  <Fragment>
                    <svg aria-hidden="true" role="status" className="inline w-4 h-4 mr-3 text-white animate-spin"
                      viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB" />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor" />
                    </svg>
                    <span>Submitting</span>
                  </Fragment>
                )}
                {!isSubmitting && (
                  <Fragment>
                    Next
                  </Fragment>
                )}
              </button>
            </div>


          </form>

        </Fragment>
      )}
    </Formik>
  );
}

export default BankWelcome;
